import Pageable from "./pageable";
import Sort from "./sort";

export default class ContentWrapper<T> {
  content: T[];
  pageable: Pageable;
  first: boolean;
  last: boolean;
  totalPages: number;
  totalElements: number;
  sort: Sort;
  numberOfElements: number;
  size: number;
  number: number;
}



// WEBPACK FOOTER //
// ./src/models/content-wrapper/content-wrapper.ts